
import React from 'react';
import './ClickOnMap.css'
import L from "leaflet";
import Parser from 'html-react-parser';
import RealTime from './CreazioneRealTime'
import axios from 'axios'
import i18n from 'i18next';
import createStringDiv from './CreateStringDiv'
import removeOldLayer from './RemoveOldLayer'
import { Trans } from 'react-i18next';
import {useTranslation} from 'react-i18next'
import iconMW from './mw.gif'
import iconUpdate from './update-icon.png'
import arrowRight from './arrow-right.svg'

var flag = false


const DrawerLayerToc = (props,layer,latlng) => {
  const {t} = useTranslation()

  function VisualizzaOrariRT () {
      
      if(props.data.data.arrayLayer.arrayLayer.length > 0 && props.data.data.arrayLayer.arrayLayer[0].nome === "Fermate TPL"){
      return(<div><button class="fermateRealTimeButton" onClick={RE}><Trans>Orari real-time (se disponibili)</Trans></button></div>)}else{return null}
  }

  function VisualizzaLinee () {      
    if(props.data.data.arrayLayer.arrayLayer.length) ViewTimetable(props.data.data.arrayLayer.arrayLayer[0],props.data.data.latLongLayer.latLongLayer)
    //return(<div><button class="fermateRealTimeButton" onClick={RELinee}><Trans>Linee di trasporto pubblico</Trans></button></div>)}else{return null}
  }

  function getContainer(){
    let tabella = document.getElementsByClassName("tableOrari")
    for(let el of tabella){el.remove()}
    let id = document.getElementById("Disponibile")
    if(id !== null){id.remove()} 
    var container = document.getElementById("orari")
    let title =  null
    if(container) title = container.getElementsByTagName('h3')
    if(title) {for(let el of title){el.remove()}}
    return container
  }

  //Visualizza i prossimi passaggi alla fermata, anche realtime se disponibili nel campo departure_time_rt
  async function ViewTimetable (layer2,latlng2){
   
    var container = getContainer()
    var dati = createStringDiv(layer2 ,latlng2)
    //dati.then(function (result) {  
    if(dati){    
      let result = dati
      if (!flag && result.id !== "" && result.id !== null) {   
        flag = true
        let url = `${window.configFile.httpProxy.urlOrari}/${result.id}`
        if(result.comune && !result.type) url = `${window.configFile.httpProxy.urlOrari}/${result.comune}/${result.id}`
        if(result.comune && result.type) url = `${window.configFile.httpProxy.urlOrari}/${result.comune}/${result.type}/${result.id}`
        //if(result.id && result.fermata.includes('Aeroporto')) url = `${window.configFile.httpProxy.urlOrariAerei}/${result.id}`
        //else if(result.id) url = `${window.configFile.httpProxy.urlOrari}/${result.id}?comune=${result.comune}`
        axios.get(url,{headers: window.tp_headers})
        .then(response => setTimeout(() =>{
                if(response.status === 200) {
                  flag = false
                  if(response.data.length >0) tableConstruct (response.data,container,props)
                  //return response.data
                }
              }),1000)
              .catch(error => { })                              
            
      }
    }
  }

  function tableConstruct (data,container,props){

    const clickLine = (evt) =>{
        
      //let variabile = {}   
      //variabile = data.realtimeStops[evt.target.parentElement.parentElement.id]      
      //props.changeAziendaRealTime(variabile.idAzienda)
      //props.changeLineaRealTime(variabile.idLinea)
      //props.data.data.aziendaRealTime.aziendaRealTime = variabile.idAzienda
      //props.data.data.lineaRealTime.lineaRealTime = variabile.idLinea
      
      if(evt.target.parentElement.id) {
        props.data.data.trip = evt.target.parentElement.id
        props.data.data.lineaRealTime.lineaRealTime = evt.target.parentElement.id
      }
      else {
        props.data.data.trip = evt.target.parentElement.parentElement.id
        props.data.data.lineaRealTime.lineaRealTime = evt.target.parentElement.parentElement.id
      }
      

      props.data.data.changePolyReal(true)
      props.data.data.changeLayerDrawer(false)
    }

    container.innerHTML = ""
    //let tabella = document.getElementsByClassName("tableOrari")
    //for(let el of tabella){el.remove()}
    let title = L.DomUtil.create('h3','',container)
    //title.innerHTML = i18n.t("Prossime partenze") + ` (${new Date().toLocaleTimeString('it-IT').substring(0, 5)})` + `<img src=${iconUpdate} alt='Update' title='Update' id='update_button' onClick="document.getElementsByClassName('infoButtonPopUp')[0].click()"/>`

    title.innerHTML = i18n.t("Prossime partenze") + ` (${new Date().toLocaleTimeString('it-IT').substring(0, 5)})`
    let imageUpdate = L.DomUtil.create('img','imageUpdate',title)  
    imageUpdate.src = iconUpdate
    imageUpdate.id = 'update_button'
    imageUpdate.title = 'Update'
    imageUpdate.alt = 'Update'
    imageUpdate.onclick = VisualizzaLinee //function (){document.getElementsByClassName('infoButtonPopUp')[0].click()}

    let table = L.DomUtil.create('table','tableOrari',container)
    let thead = L.DomUtil.create('thead','theadclass',table)
    let tr = L.DomUtil.create('tr','tableStyle',thead)
    let td1 = L.DomUtil.create('td','keyStyle',tr)
    let td2 = L.DomUtil.create('td','keyStyle',tr)
    let td3 = L.DomUtil.create('td','keyStyle',tr)     
    td1.innerText = i18n.t("Azienda")
    td2.innerText = i18n.t("Linea")
    td3.innerText = i18n.t("Orario")                
    let tbody = L.DomUtil.create('tbody','tbodystyle',table)

    data.sort(function(a, b){
      if(a.date.localeCompare(b.date) == 0){
        if(a.departure_time_rt && b.departure_time_rt) return a.departure_time_rt.localeCompare(b.departure_time_rt);
        if(a.departure_time_rt && !b.departure_time_rt) return a.departure_time_rt.localeCompare(b.departure_time);
        if(!a.departure_time_rt && b.departure_time_rt) return a.departure_time.localeCompare(b.departure_time_rt);
        return a.departure_time.localeCompare(b.departure_time);
      }
      else return a.date.localeCompare(b.date);
    });
    data.map((linea,index)=> {
      let trbody = L.DomUtil.create('tr','tbodystyle',tbody)
      trbody.id = linea.trip_id
      trbody.index = index
      trbody.onclick = clickLine
      let tdtbody1 = L.DomUtil.create('td','',trbody)
      let tdtbody2 = L.DomUtil.create('td','',trbody)  
      let tdtbody3 = L.DomUtil.create('td','',trbody)    
      tdtbody1.innerText = (linea.agency_name.length>20)?linea.agency_name.substring(0, 20)+"...":linea.agency_name
      //tdtbody1.id = linea.trip_id
      if(linea.res_group === 'AEREO') tdtbody2.innerHTML += (i18n.t("VOLO") + ' ' + linea.trip_short_name)
      //else tdtbody2.innerText += (' ' + i18n.t("VERSO") + ' ' + linea.direction_stop_name)
      else {
        if(linea.route_short_name) tdtbody2.innerHTML = linea.route_short_name
        else tdtbody2.innerHTML = linea.route_long_name
      }
        
      tdtbody2.innerHTML += '<br>'
      let imageArrow = L.DomUtil.create('img','imagestyle-arrow',tdtbody2)
      imageArrow.src = arrowRight
      imageArrow.title = i18n.t("VERSO")      
      let divDirection = L.DomUtil.create('div','div-direction',tdtbody2)
      divDirection.innerHTML = linea.direction_stop_name
      //tdtbody2.innerHTML += ('<br>' + linea.direction_stop_name)
      
      var orario
      orario=(linea.departure_time_rt)?linea.departure_time_rt:linea.departure_time
      orario = orario.substring(0, 5)
      if(linea.date.substring(6) > new Date().getDate()) orario += " (" + i18n.t("domani") + ")"
      if(orario.substring(0, 2)>=24) orario += (orario.substring(0, 2)-24 + orario.substring(2) + ` (${i18n.t("domani")})`)
      if(linea.departure_time_rt) {
        tdtbody3.className = "startOra2"
        //tdtbody3.innerHTML = `<img src=${iconMW} alt='RT' title='Real-time'/>`
        let imageRT = L.DomUtil.create('img','imagestyle',tdtbody3)  
        imageRT.src = iconMW
        imageRT.title = 'Real-time'
      }

      tdtbody3.innerHTML += orario
      if(linea.message && linea.message !== "None") tdtbody3.innerHTML += ('<br/><span class="linea_message">' + `${i18n.t(linea.message)}` + '</span>')
  })
  }

  // DEPRECATED VECCHIA FUNZIONE
  function RE (){
   
    let tabella = document.getElementsByClassName("tableclass")
      //if (tabella.length > 0){
       
      //}
      for(let el of tabella){el.remove()}
      let id = document.getElementById("Disponibile")
      if(id !== null){
      id.remove()
      }


    var layer2 = props.data.data.arrayLayer.arrayLayer[0]
    
    var latlng2 = props.data.data.latLongLayer.latLongLayer
    
    var container = document.getElementById("aaa")
    var div = L.DomUtil.create('div','',container)
    var dati = createStringDiv(  layer2  ,latlng2 )
    dati.then(function (result) {
    var flag = false
    
    if (flag === false) {
      

        axios.get(`${window.configFile.httpProxy.urlOTP}/stops`,{headers: window.tp_headers})
          .then(response => {
            
            const id = response.data.find(element => { return element.id.split(":")[1] === result.id })
            
            try {
              
              axios.get(`${window.configFile.httpProxy.urlOTP}/stops/${id.id}/routes`,{headers: window.tp_headers})
                
                .then(response => {   
                  
                  axios.get(`${window.configFile.httpProxy.urlCMRStops}/${response.data[0].agencyName}/${id.id.split(":")[1]}`,{headers: window.tp_headers})
                    .then(response => setTimeout(() =>{
                      
                     
                      if(response.status === 200){
                        document.getElementById("Disponibile").remove()
                        
                       let table = L.DomUtil.create('table','tableclass',div)
                       RealTime(response,props,table)
                       
                       }else{console.log("a")}
                      
                       
                        
                      
                    }),1000)
                     .catch(error => { })
                    
                     
                     
                    
                })
                 .catch(error => { })
                
                
                 //return(<div><p id="Disponibile">REAL TIME NON DISPONIBILE</p></div>)
                 div.innerHTML += '<p id="Disponibile">REAL TIME NON DISPONIBILE</p>'
                                          
            } catch (error) {
              //return(<div><p id="Disponibile">REAL TIME NON DISPONIBILE</p></div>)
              //div.innerHTML += '<p id="Disponibile">REAL TIME NON DISPONIBILE</p>'
            }
          })
        flag = true
        
      

    }
    }) 
  }


 /*    console.log("sono in drawertoc")
 console.log(props.data.data.layerInformation.layerInformation,"PROPSTOC")
 var container = L.DomUtil.create('div','custom');

  container.innerHTML  = ""
 container.innerHTML += `<div class="superiorDiv"><p1 class="infoText">Informazioni</p1></div>`
 console.log(container,"container")
  var div = L.DomUtil.create('div','',container )
 div.className = "informationPopUp"
 div.innerHTML += props.data.data.layerInformation.layerInformation
 console.log(typeof(container))
 console.log(div,"mydiv")   */
 return (
 <div>
     <div>
     {Parser(props.data.data.layerInformation.layerInformation)}
     </div>
     
     <div id="orari">
     </div>
     
       {VisualizzaLinee()} 
     <div id="aaa">
      {/*VisualizzaOrariRT()*/} 
     </div>
</div>)

}
export default DrawerLayerToc